import React, { useMemo, useState } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
} from "@mui/material";
import VantageListHead from "../../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  getComparator,
} from "../../../../../component/Methods";
import {
  rebalancerTablePanelSx,
  getRebalancerScrollableTableContainerSx,
  getRebalancerLocatesTableRowSx,
  getRebalancerLocatesTableCellSx,
} from "../../../styles/rebalancerStyles";

const Approved = ({ approved, tableHeader }) => {
  const theme = useTheme();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("ticker");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredApproved = useMemo(
    () => (approved || []).filter((item) => item.shareCount > 0),
    [approved]
  );

  const data = useMemo(
    () => applySortFilter(filteredApproved, getComparator(order, orderBy)),
    [filteredApproved, order, orderBy]
  );

  return (
    <>
      <Box sx={rebalancerTablePanelSx}>
        <Typography sx={{ fontWeight: "bold", fontSize: "18px", mb: 1, flexShrink: 0 }}>
          Approved Locates
        </Typography>
        <TableContainer sx={getRebalancerScrollableTableContainerSx(theme)}>
          <Table
            size="small"
            stickyHeader
            aria-label="a dense table"
            sx={{
              height: "max-content",
            }}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {filteredApproved.length === 0 ? (
                <TableRow>
                  <Tablecell colSpan={tableHeader.length} align="center">
                    No Locates Required
                  </Tablecell>
                </TableRow>
              ) : null}
              {data?.map((row, index) => (
                <TableRow
                  key={`${row?.ticker}-${row?.fund}-${index}`}
                  sx={getRebalancerLocatesTableRowSx(theme)}
                >
                  <Tablecell align="left" sx={getRebalancerLocatesTableCellSx(theme, "left")}>
                    {row?.ticker?.toUpperCase() || ""}
                  </Tablecell>
                  <Tablecell align="right" sx={getRebalancerLocatesTableCellSx(theme, "right")}>
                    {row?.shareCount}
                  </Tablecell>
                  <Tablecell align="left" sx={getRebalancerLocatesTableCellSx(theme, "left")}>
                    {row?.fund}
                  </Tablecell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default Approved;
